import { useEffect, useRef, useState } from "react";
import { API } from "@/lib/api";

// Accumulates real playing time once per second; flushes to backend every 3s, on end and on exit.
export function useWatchTracker(sessionId, probeRef) {
  const watched = useRef(0);
  const minutes = useRef(new Set());
  const last = useRef({ position: 0, duration: 0, ended: false });
  const [view, setView] = useState({ watched: 0, position: 0, duration: 0, playing: false, ended: false });

  useEffect(() => {
    if (!sessionId) return;
    const payload = () => JSON.stringify({ session_id: sessionId, watched_seconds: watched.current, minutes: [...minutes.current], ...last.current });
    const send = () => fetch(`${API}/public/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload(), keepalive: true }).catch(() => {});
    let ticks = 0;
    let wasEnded = false;
    const iv = setInterval(() => {
      const s = probeRef.current?.() || {};
      if (s.playing) {
        watched.current += 1;
        minutes.current.add(Math.floor((s.position || 0) / 60));
      }
      last.current = { position: s.position || 0, duration: s.duration || 0, ended: !!s.ended };
      setView({ watched: watched.current, position: last.current.position, duration: last.current.duration, playing: !!s.playing, ended: !!s.ended });
      ticks += 1;
      if ((ticks % 3 === 0 && s.playing) || (s.ended && !wasEnded)) send();
      wasEnded = !!s.ended;
    }, 1000);
    const flush = () => send();
    const onVis = () => document.visibilityState === "hidden" && flush();
    window.addEventListener("pagehide", flush);
    document.addEventListener("visibilitychange", onVis);
    return () => {
      clearInterval(iv);
      flush();
      window.removeEventListener("pagehide", flush);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [sessionId, probeRef]);

  return view;
}
